<template>
  <Head :title="`Scorecard - ${client.name}`" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <scorecard 
            :client="client" 
            :time_period="time_period" 
          ></scorecard>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  client: Object,
  time_period: String,
  auth: Object
});
</script>

